import LocalStorage from 'local-storage';

export class Remember {
    constructor(inputElement, key) {
        this.inputElement = inputElement;
        this.key = key;

        this.init();
    }

    init() {
        const scope = this;

        const uri = window.location.pathname.replace(/\//g,'');

        if (this.inputElement) {
            if (uri == 'quickorder' || uri == 'search') {
                this.inputElement.value = localStorage.getItem(this.key);
            } else {
                this.inputElement.value = '';
            }

            window.onbeforeunload = event => {
                localStorage.setItem(scope.key, this.inputElement.value);
            }

            this.inputElement.oninput = event => {
                if (this.timeout !== undefined) {
                    window.clearTimeout(this.timeout);
                }

                this.timeout = window.setTimeout(function () {
                    localStorage.setItem(scope.key, scope.inputElement.value);
                }, 1000);
            }
        }
    }
}
